import { AiFillHome } from "react-icons/ai";
import { BsPersonFill } from "react-icons/bs";
import { MdHomeRepairService } from "react-icons/md";
import { AiFillAppstore } from "react-icons/ai";
import { AiFillMessage } from "react-icons/ai";

const FloatingDataLink = [
	// { id: 1, link: "/", icon: <AiFillHome /> },
	// { id: 2, link: "/About", icon: <BsPersonFill /> },
	// { id: 3, link: "/services", icon: <MdHomeRepairService /> },
	// { id: 4, link: "/Portfolio", icon: <AiFillAppstore /> },
	// { id: 5, link: "/Contact", icon: <AiFillMessage /> },
	{ id: 1, link: "#header", icon: <AiFillHome /> },
	{ id: 2, link: "#about-id-routing", icon: <BsPersonFill /> },
	{ id: 3, link: "#services-id-routing", icon: <MdHomeRepairService /> },
	{ id: 4, link: "#portfolio-id-routing", icon: <AiFillAppstore /> },
	{ id: 5, link: "#contact-id-routing", icon: <AiFillMessage /> },
];
export default FloatingDataLink;
